export const current = (s) => {
    return s.current
}

export const get = s => (id) => {
    return s.data['I'+id]
}

export const grub = s => (id, path) => {
    let data = get(id)
    
    path = path.split('.')
    
    for(let i=0; i<path.length; i++) {
        let p = path[i]
        
        if(typeof data[p] !== 'undefined')
            data = data[p]
        else
            return undefined
    }
    
    return data
}

export default {
    current,
    get, grub
}
